export interface Frontmatter {
  [key: string]: string | undefined;
}

export interface ParsedContent {
  frontmatter: Frontmatter;
  body: string;
  wordCount: number;
}

const FRONTMATTER_RE = /^---\s*\n([\s\S]*?)\n---\s*\n?/;

export function parseFrontmatter(content: string): ParsedContent {
  const match = content.match(FRONTMATTER_RE);

  if (!match) {
    return {
      frontmatter: {},
      body: content,
      wordCount: countWords(content),
    };
  }

  const raw = match[1];
  const body = content.slice(match[0].length);
  const frontmatter: Frontmatter = {};

  for (const line of raw.split('\n')) {
    const colonIdx = line.indexOf(':');
    if (colonIdx === -1) continue;
    const key = line.slice(0, colonIdx).trim();
    let value = line.slice(colonIdx + 1).trim();
    if ((value.startsWith('"') && value.endsWith('"')) || (value.startsWith("'") && value.endsWith("'"))) {
      value = value.slice(1, -1);
    }
    if (key) frontmatter[key] = value;
  }

  return { frontmatter, body, wordCount: countWords(body) };
}

function countWords(text: string): number {
  const stripped = text
    .replace(/```[\s\S]*?```/g, '')
    .replace(/`[^`]*`/g, '')
    .replace(/!\[.*?\]\(.*?\)/g, '')
    .replace(/\[([^\]]*)\]\(.*?\)/g, '$1')
    .replace(/#{1,6}\s/g, '')
    .replace(/[*_~>|`#\-]/g, '');

  return stripped.split(/\s+/).filter((w) => w.length > 0).length;
}
